let alphabet = [];

for (let i = 0; i < 26; i++) {
  alphabet.push((i + 10).toString(36));
}

export default alphabet;
